module.exports = __webpack_public_path__ + "img/Logo_footer.d0bf4167.svg";